<template>
  <div
    class="Overlay"
    data-action="close-modal"
    @click.self="closeModal"
    v-if="visible"
  >
    <div
      class="ModalBox ModalBox--central Modal--filters"
      id="NewUserModal"
    >
      <div class="ModalBox-header d-flex justify-content-between align-items-center  p-3">
        <div
          class="Ctrl Ctrl--24 u-pointer"
          data-action="close-modal"
          @click="closeModal"
        >
          <svg
            focusable="false"
            aria-hidden="true"
            aria-label="Edit"
          >
            <use xlink:href="#close-icon"></use>
          </svg>
        </div>
        <div
          class="Tit Tit--modal  w-100"
          v-t="{path: hasCreatedPasscode ? 'card_action_request_passcode' : 'card_action_passcode_not_found' }"
        ></div>
      </div>
      <div class="ModalBox-container pl-3 pr-3 pt-3">
        <form
          class="Form p-2"
          @submit.prevent="submit"
          v-if="hasCreatedPasscode"
        >
          <div class="row d-flex flex-column mx-auto justify-content-center align-items-center">
            <div class="col-12">
              <p
                class="p Fuell-Text"
                v-t="{path: 'card_action_input_passcode'}"
              > </p>
            </div>
            <div
              class="col-12 col-lg-6 mb-2 d-flex justify-content-center align-items-center"
              v-if="!cardToggleStatus"
            >
              <passcode-picker
                key="passcodeInput"
                @complete="submit"
                v-if="!isCallingCards"
              ></passcode-picker>
              <spinner v-else></spinner>
            </div>
            <div
              class="col-12 d-flex justify-content-center align-items-center p-3"
              v-if="!isCallingCards"
            >
              <a
                href="#"
                class="link"
                @click.prevent.stop="showRequestResetPasscodeConfirmModal"
              > {{$t('user_profile_form_forgot_passcode_action')}}</a>
            </div>
            <div
              class="d-flex flex-column justify-content-center"
              v-if="isRequestingResetPasscode"
            >
              <spinner />

            </div>

          </div>
        </form>
        <div
          class="row d-flex flex-column mx-auto justify-content-center align-items-center"
          v-else
        >
          <div class="col-12 p-2">
            <p
              class="p Fuell-Text"
              v-t="{path: 'card_passcode_request_instructions'}"
            > </p>
          </div>
          <div class="col-12 p-3">
            <router-link
              to="/profile"
              class="Fuell-Button block blue d-flex justify-content-center"
              v-t="{ path:'action_go_to_profile'}"
            >

            </router-link>
          </div>
        </div>
      </div>
    </div>
    <confirm-modal
      :open.sync="showRequestResetPasscodeConfirmModalFlag"
      v-if="showRequestResetPasscodeConfirmModalFlag"
      :title="'user_profile_forgot_passcode_modal_header'"
      :dismissText="'ACTION_CANCEL'"
      :message="'user_profile_forgot_passcode_message'"
      :acceptText="'user_profile_forgot_passcode_confirm_request_reset_passcode'"
      :acceptBtnClass="'blue'"
      @accept="requestResetPasscode"
    ></confirm-modal>
  </div>

</template>

<script>
import _modalHandlerMixin from '@/components/Commons/_mixins/_modalHandlerMixin'
import _usersRequestResetPasscodeMixin from '@/modules/users/_mixins/_usersRequestResetPasscodeMixin'
import PasscodePicker from '@/modules/users/_components/_shared/PasscodePicker'
import Spinner from '@/components/Commons/Spinner'
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')
export default {
  name: 'CardActionPasscodeRequestedModal',
  mixins: [_modalHandlerMixin, _usersRequestResetPasscodeMixin],
  components: { PasscodePicker, Spinner, ConfirmModal },
  props: {
    cardUserOwnerId: {
      type: [String, Number]
    },
    cardStatus: {
      type: String
    }
  },
  data () {
    return {
      passcode: '',
      showConfirmModalFlag: false
    }
  },
  methods: {
    async fetchCardOwner () {
      await this.$store.dispatch('UsersStore/fetchUser', this.cardUserOwnerId)
    },
    submit (event) {
      const passCodeConfirmAction = {
        passcode: event,
        cardStatus: this.cardStatus
      }
      this.$emit('passCodeConfirm', passCodeConfirmAction)
    }
  },
  computed: {
    userId () {
      return this.$store.getters['LoginStore/user'].id || 0
    },
    loggedUser () {
      return this.$store.getters['UsersStore/userLogged']
    },
    userOwner () {
      return this.loggedUser?.id === this.cardUserOwnerId || false
    },
    hasCreatedPasscode () {
      if (this.loggedUser && this.loggedUser.passCodeCreated) {
        return this.loggedUser.passCodeCreated
      }
      return false
    },
    isCallingCards () {
      return this.$store.getters['CardsStore/isCallingCards']
    },
    cardToggleStatus () {
      return this.$store.getters['CardsStore/cardStatusToggleSuccess']
    }
  },
  watch: {
    cardUserOwnerId: {
      handler: 'fetchCardOwner',
      immediate: true
    }
  }

}
</script>

<style scoped>
.ModalBox-header,
.ModalBox-container {
  position: unset;
}
.link {
  color: var(--blue-action-1-active);
  text-decoration: underline !important;
  text-align: center;
  font-weight: 500;
}
</style>
